module.exports = __webpack_public_path__ + "static/media/014ty@3x.74a87f3b.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/014ty@3x.png
// module id = 1662
// module chunks = 0 1